import { ButtonHTMLAttributes, FC } from 'react';

import { IconName, Size } from '@purpur/library/icon';
import { IconChevronRight } from '@purpur/library/icon/chevron-right';

import { RectButtonText, StyledButton } from './RectShapedButton.styles';
import { RoundFilledIcon } from './RoundFilledIcon';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;
type Props = { icon?: IconName | string; iconSize?: Size } & ButtonProps;

export const RectShapedButton: FC<Props> = ({ children, icon, iconSize, type = 'button', ...inheritedProps }) => (
    <StyledButton type={type} {...inheritedProps}>
        {!!icon && <RoundFilledIcon icon={icon} size={iconSize} />}
        {typeof children === 'string' ? <RectButtonText>{children}</RectButtonText> : children}
        <IconChevronRight />
    </StyledButton>
);
